import React from 'react';

export default class Puff extends React.PureComponent {
    static propTypes = {};

    render() {
        return <div className="puffContainer" />;
    }
}

